/* eslint-disable compat/compat */
class ProductRankCustomiser extends window.BAO.CustomElement {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    if (this.externalEls?.nameCartProperty?.exists && this.els?.name?.exists) {
      this.els.name.element.addEventListener('input', event => {
        this.handleInput('name', event.target)
      })
    }

    if (this.externalEls?.rankCartProperty?.exists && this.els?.rank?.exists) {
      this.els.rank.element.addEventListener('input', event => {
        this.handleInput('rank', event.target)
      })
    }

    if (this.externalEls?.unitCartProperty?.exists && this.els?.unit?.exists) {
      this.els.unit.element.addEventListener('input', event => {
        this.handleInput('unit', event.target)
      })
    }
  }

  handleInput (inputType, target) {
    const inputValue = target.value
    this.updateRankCustomiserLineItemProperty(inputType, inputValue)
    this.updateCharacterCount(inputType, inputValue, target)
    this.updateCustomisedCartProperty()
  }

  updateRankCustomiserLineItemProperty (inputType, inputValue) {
    if (
      this.els?.[inputType]?.exists &&
      this.els[inputType].element === document.activeElement
    ) {
      this.externalEls[`${inputType}CartProperty`].element.value = inputValue
    }
  }

  updateCharacterCount (inputType, inputValue, target) {
    if (
      this.els?.[inputType]?.exists &&
      this.els[inputType].element === document.activeElement
    ) {
      const fieldRow = this.els?.[inputType].element.closest(
        '[data-product-rank-customiser-el="fieldRow"]'
      )

      if (fieldRow) {
        const characterLimitsContainerEl = fieldRow.querySelector(
          '[data-product-rank-customiser-el="characterLimits"]'
        )
        const initialCountEl = fieldRow.querySelector(
          '[data-product-rank-customiser-el="initialCount"]'
        )
        const limitCountEl = fieldRow.querySelector(
          '[data-product-rank-customiser-el="limitCount"]'
        )

        if (characterLimitsContainerEl && initialCountEl && limitCountEl) {
          const limitCount = parseInt(limitCountEl.innerText, 10)
          const currentCount = inputValue.length

          if (currentCount <= limitCount) {
            initialCountEl.innerText = currentCount
          } else {
            target.value = inputValue.substring(0, limitCount)
            initialCountEl.innerText = limitCount
          }

          if (currentCount === limitCount) {
            characterLimitsContainerEl.classList.add(
              'prd-DetailsRankCustomiser_Limit-isMaximum'
            )
          } else {
            characterLimitsContainerEl.classList.remove(
              'prd-DetailsRankCustomiser_Limit-isMaximum'
            )
          }
        }
      }
    }
  }

  updateCustomisedCartProperty () {
    const nameValue = this.els?.name?.element.value || ''
    const rankValue = this.els?.rank?.element.value || ''
    const unitValue = this.els?.unit?.element.value || ''

    const customisedCartPropertyEl = this.externalEls?.customisedCartProperty
      ?.element

    if (customisedCartPropertyEl) {
      if (nameValue || rankValue || unitValue) {
        customisedCartPropertyEl.value =
          window.theme.strings.rankCustomiserCustomisedYes
      } else {
        customisedCartPropertyEl.value = ''
      }
    }
  }
}

if (!customElements.get('product-rank-customiser')) {
  customElements.define('product-rank-customiser', ProductRankCustomiser)
}
